/* base.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["before", "contentElement", "after", "testId", "appearance", "style", "color", "href", "className"];
import "./base.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
// Border colors - Hardcoded for Visual Refresh - to be removed with labelling system work
var borderColors = {
  standard: "_1h6d14je",
  blue: "_1h6duisw",
  red: "_1h6da2c0",
  yellow: "_1h6deh2r",
  green: "_1h6d18uw",
  teal: "_1h6d1ug6",
  purple: "_1h6d157s",
  lime: "_1h6dn0nx",
  magenta: "_1h6d1lf6",
  orange: "_1h6dh727",
  grey: "_1h6d14je",
  standardLink: "_1h6d14je",
  blueLight: "_1h6duisw",
  redLight: "_1h6da2c0",
  yellowLight: "_1h6deh2r",
  greenLight: "_1h6d18uw",
  tealLight: "_1h6d1ug6",
  purpleLight: "_1h6d157s",
  limeLight: "_1h6dn0nx",
  magentaLight: "_1h6d1lf6",
  orangeLight: "_1h6dh727",
  greyLight: "_1h6d14je"
};
var baseStyles = null;
var interactiveStyles = null;
var focusRingStyles = null;
var BaseTag = /*#__PURE__*/React.forwardRef(function BaseTag(_ref, ref) {
  var before = _ref.before,
    contentElement = _ref.contentElement,
    after = _ref.after,
    testId = _ref.testId,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance,
    style = _ref.style,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'standard' : _ref$color,
    href = _ref.href,
    className = _ref.className,
    other = _objectWithoutProperties(_ref, _excluded);
  var isLink = Boolean(href);
  var isRemovable = Boolean(after);
  var isInteractive = isLink || isRemovable;
  return /*#__PURE__*/React.createElement("span", _extends({}, other, {
    ref: ref,
    style: _objectSpread({}, style)
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: ax(["_zulp1b66 _2rko12b0 _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _18zr1b66 _1e0c116y _vchhusvi _1ul9idpf _4t3iv47k _kqswh2mm _4cvr1h6o _bfhksm61 _syazi7uo _80om73ad", isInteractive && "_1e38dfik _7glxv77o", isLink && "_irr31dpa _1di6fcek", borderColors[color], className]),
    "data-testid": testId
  }), before, contentElement, after);
});

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default BaseTag;